export enum PlanSeries {
  A = "A",
  B = "B",
  E = "E",
  P = "P",
}

export enum BackgroundType {
  FLOOR_PLAN = "FLOOR_PLAN",
  ROOF_PLAN = "ROOF_PLAN",
}

export enum BackgroundVisibility {
  FULL = "FULL",
  BACKGROUND = "BACKGROUND",
}
